import ErrorBoundary from './ErrorBoundary';
export default ErrorBoundary;
//# sourceMappingURL=index.js.map
